"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const SuspenseContext_1 = require("../../contexts/SuspenseContext");
const helpers_1 = require("../../lib/helpers");
const SuspenseEmpty = (props) => {
    const { children } = props;
    const { status, hook } = react_1.useContext(SuspenseContext_1.SuspenseContext);
    const primitiveProps = helpers_1.usePrimitiveProps(props);
    return (react_1.default.createElement(react_1.default.Fragment, null, status === 'completed' && hook.data.length <= 0 ? (react_1.default.createElement("div", Object.assign({}, primitiveProps), children !== null && children !== void 0 ? children : react_1.default.createElement(react_1.default.Fragment, null, "Sorry, we don't have anything to show."))) : null));
};
exports.default = withJourney_1.default('j-suspense-empty', SuspenseEmpty);
